import { Layout, Space, Input, Typography, Grid, Button } from 'antd';
import { SearchOutlined, DashboardOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useState } from 'react';
import { TenantSelector } from './TenantSelector';
import { useAuth } from '../../auth/AuthContext';

const { Header: AntHeader } = Layout;
const { Title } = Typography;
const { useBreakpoint } = Grid;

export function Header() {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const screens = useBreakpoint();
  const { user, signOut } = useAuth();

  const handleSearch = (value: string) => {
    if (value.trim()) {
      navigate(`/search?q=${encodeURIComponent(value.trim())}`);
    }
  };

  return (
    <AntHeader
      role="banner"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: screens.md ? '0 24px' : '0 12px',
        background: '#001529',
        flexWrap: 'wrap',
        height: 'auto',
        minHeight: 64,
      }}
    >
      <Link to="/" style={{ textDecoration: 'none' }} aria-label="Go to dashboard">
        <Space>
          <DashboardOutlined
            style={{ fontSize: screens.md ? 24 : 20, color: '#fff' }}
            aria-hidden="true"
          />
          <Title
            level={4}
            style={{
              margin: 0,
              color: '#fff',
              fontSize: screens.md ? undefined : 16,
            }}
          >
            {screens.sm ? 'PDR Stats Dashboard' : 'PDR Stats'}
          </Title>
        </Space>
      </Link>

      <Space size={screens.md ? 'large' : 'middle'} wrap>
        <Input.Search
          placeholder={screens.md ? 'Search trace/job/span ID...' : 'Search...'}
          allowClear
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onSearch={handleSearch}
          style={{ width: screens.md ? 300 : screens.sm ? 200 : 150 }}
          prefix={<SearchOutlined aria-hidden="true" />}
          aria-label="Search for trace, job, or span ID"
        />
        <TenantSelector />
        {user && (
          <>
            <Space size="small">
              <UserOutlined style={{ color: 'rgba(255,255,255,0.65)' }} />
              <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>
                {user.getUsername()}
              </span>
            </Space>
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={signOut}
              size="small"
              style={{ color: 'rgba(255,255,255,0.65)' }}
            >
              {screens.md ? 'Sign Out' : ''}
            </Button>
          </>
        )}
      </Space>
    </AntHeader>
  );
}
